<template>
  <div :id="id" :data-clipboard-target="`#${id}`" :class="{'styled' : !suppressStyles}" class="clipboard-text">{{ text }}</div>
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue'
import ClipboardJS from 'clipboard'

export default defineComponent({
  name: 'ClipboardText',
  props: {
    text: {
      type: String,
      required: true,
    },
    /* Use a custom id if more than one clipboard lives on a page to avoid multiple targeting */
    id: {
      type: String,
      default: 'text',
    },
    suppressStyles: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      clipboard: null as any,
    }
  },

  mounted() {
    this.clipboard = markRaw(new ClipboardJS(`#${this.id}`))
    this.clipboard.on('success', (e: any) => {
      // @ts-ignore
      this.$messaging.showSuccess('Copied to your clipboard!')
      e.clearSelection()
    })
  },

  beforeUnmount() {
    this.clipboard.destroy()
  },
})
</script>

<style lang="scss">
.clipboard-text {
  cursor: copy;

  &.styled {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 18px;
    padding: 10px;
    border-radius: 8px;
    font-weight: $bold;
    background-color: var(--color-background-green);

    @include media-breakpoint-down(sm) {
      word-break: break-all;
    }
  }
}
</style>
